module.exports = __webpack_public_path__ + "img/qrcode.1840332b.png";